<template>
    <router-view/>
</template>
<script>
export default {
  data() {
    return {
      result: '',
    }
  },
 
  mounted() {
    // 本地存储的随机字符串
    if (!this.$getItem('result')) {
      var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < 32; i++) {
        this.result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      this.$setItem('result', this.result)
      this.$setCookie('result', this.result)
    } else {
      this.result = this.$getItem('result')
      this.$setCookie('result', this.$getItem('result'))
    }
    // 获取渠道id
    const urlParams = new URLSearchParams(window.location.search);
    const t = urlParams.get('t');
    if (t) {
      let http = `${this.$baseUrl}/#/register?result=${this.result}&t=${t}`
      let https = `${this.$baseUrl}/#/login?result=${this.result}&t=${t}`
      this.$setCookie('http', http)
      this.$setCookie('https', https)
    } else if (this.$getCookie('http')) {
      console.log('$getCookie里面取');
    } else {
      let http = `${this.$baseUrl}/#/register?result=${this.result}`
      let https = `${this.$baseUrl}/#/login?result=${this.result}`
      this.$setCookie('http', http)
      this.$setCookie('https', https)
    }
      console.log( this.$getCookie('http'));
      console.log( this.$getCookie('https'));
  },
}
</script>
<style lang="scss">
.named{
    width: 100%;
    display: flex;
    justify-content: center;
  }
  // 隐藏滚动条
//   *{
//  ::-webkit-scrollbar {
//     /*隐藏滚轮*/
//     display: none;
//   }
// }
</style>
